import { afterNextRender, Component, ElementRef, ViewChild, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-lite-testimonial-section',
  imports: [],
  templateUrl: './lite-testimonial-section.html',
  styleUrl: './lite-testimonial-section.css',
})
export class LiteTestimonialSection {
  private sanitizer = inject(DomSanitizer);

  @ViewChild('scrollContainer') scrollContainer!: ElementRef<HTMLDivElement>;
  scroll!: (direction: 'left' | 'right') => void;

  constructor() {
    afterNextRender(() => {
      this.scroll = (direction: 'left' | 'right') => {
        const el = this.scrollContainer.nativeElement;
        const scrollAmount = 440;
        el.scrollBy({
          left: direction === 'right' ? scrollAmount : -scrollAmount,
          behavior: 'smooth',
        });
      };
    });
  }

  safeUrl(url: string): SafeResourceUrl {
    const embedUrl = url
      .replace('https://www.youtube.com/shorts/', 'https://www.youtube.com/embed/')
      .replace('https://youtu.be/', 'https://www.youtube.com/embed/')
      .replace(/[?&]si=[^&]+/, '');
    return this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  testimonials = [
    {
      name: 'John Doe',
      text: 'Lorem ipsum, dolor sit amet consectetur adipisicing elit. Consequuntur, neque eligendi? Quod dolor excepturi ad molestias voluptate adipisci repellendus amet! Minima beatae quia.',
      videoUrl: 'https://www.youtube.com/shorts/kZK8G7E6x8U?si=-1P9f1LSHCVG9B67',
    },
    {
      name: 'Jane Smith',
      text: 'Amazing platform! It made organizing our events so much easier. The team was super helpful and responsive throughout the whole process.',
      videoUrl: 'https://www.youtube.com/shorts/kZK8G7E6x8U?si=-1P9f1LSHCVG9B67',
    },
    {
      name: 'Michael Lee',
      text: 'Highly recommend this to any event organizer. The tools provided are intuitive and the support is top-notch. Will definitely use again.',
      videoUrl: 'https://www.youtube.com/shorts/kZK8G7E6x8U?si=-1P9f1LSHCVG9B67',
    },
    {
      name: 'Sarah Connor',
      text: 'We used this for our annual conference and everything went smoothly. The dashboard gives you full visibility over registrations and tickets.',
      videoUrl: 'https://www.youtube.com/shorts/kZK8G7E6x8U?si=-1P9f1LSHCVG9B67',
    },
    {
      name: 'Tom Brown',
      text: 'Fantastic experience from start to finish. Our attendees loved the seamless check-in process and the overall event management was flawless.',
      videoUrl: 'https://www.youtube.com/shorts/kZK8G7E6x8U?si=-1P9f1LSHCVG9B67',
    },
  ];
}
